module.exports = __webpack_public_path__ + "static/media/pre-pay-circle.290c250e.svg";